import {Injectable} from '@angular/core';

import 'rxjs/add/operator/map'

import {ApiService} from './api.service';

@Injectable()
export class UserService {

    constructor(
        private apiService: ApiService) {
    }

    getUsers(data) {
        return this.apiService.http_post('/user/list', data);
    }
    addUser(user) {
        return this.apiService.http_post('/user/add', user);
    }
    updateUser(user) {
        return this.apiService.http_post('/user/update', user);
    }
    deleteUser(user) {
        return this.apiService.http_post('/user/delete', user);
    }
    isEmailRegisterd(email, id) {

        return this.apiService.http_post('/user/checkDuplicateUser', {email: email, id: id});
    }
    getUserDetails(id) {
        return this.apiService.http_get('/user/getUserDetails/' + id);
    }
    resetPassword(user) {
        return this.apiService.http_post('/user/resetPassword', user);
    }
    getChartData() {
        return this.apiService.http_get('/user/getChartData');
    }
    changeStatus(user) {
    
        return this.apiService.http_post('/user/changeStatus',user);
    }
    getCustomRoles(type) {
    
        return this.apiService.http_get('/user/getCustomRoles/'+type);
    }
    
}


// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/user.service.ts